import React from "react";
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";

import useStyleMotto from "../styles/useStyleMotto";

const Motto = (props) => {
  const classes = useStyleMotto();
  return (
    <>
      <Box>
        <Container className={classes.boxmotto} maxWidth="lg">
          <Typography className={classes.motto}>{props.motto}</Typography>
          <Typography className={classes.autore}>{props.autore}</Typography>
        </Container>
      </Box>
    </>
  );
};

export default Motto;
